<div class="widget__wrap">
  <div class="widget" id="tiles-widget">
    <h2 class="widget__header">
      <span class="widget__header__title">
        <i class="widget__header__icon ico-angle-down"></i> Navigační dlaždice
      </span>
      <span class="widget__header__tools">
        <swb-filter-list (modelChange)="filter($event)"></swb-filter-list>
        <a [routerLink]="['tiles/add']" class="cta cta--small cta--green">
          <span class="cta__light">Přidat</span> dlaždici
          <i class="ico-plus"></i>
        </a>
      </span>
    </h2>
    <div class="widget__content"><swb-tiles-list [query]="query"></swb-tiles-list></div>
  </div>
</div>
